import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-forgotpsw',
  templateUrl: './forgotpsw.component.html',
  styleUrls: ['./forgotpsw.component.css']
})
export class ForgotpswComponent implements OnInit, OnDestroy {
	data: any;
	username = "";
	isErr = false;
	errMsg = "";
	respObject: any;
  constructor(@Inject(DOCUMENT) private document: Document,private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(){
  	this.username = "";
  	this.isErr = false;
  	this.renderer.addClass(this.document.body, 'bg-dark');
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'bg-dark');
  }
  forgotPsw(){
  	if(this.username==""){
  		this.errMsg = "Please enter your User ID.";
  		this.isErr = true;
  	}  else {
  		this.isErr = false;
  		 const fd = {};
      	fd["username"] = this.username;
  		//alert("deleted");
      this._rest.forgotPsw(fd).subscribe((res) => {
        console.log(res);
        this.respObject = res;
        if(this.respObject.error==0){
          alert("Change password request has been sent to Admin.");
          this.ngOnInit();
        } else {
        	this.errMsg = this.respObject.errorMessage;
  			this.isErr = true;
        }
      });
  	}
  }

  ValidateEmail(mail){
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
		return (true)
	} else {
		return (false)
	}
  }

}
